webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DECREMENT_MAIN_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INCREMENT_MAIN_COUNTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UPDATE_LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return UPDATE_SEARCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UPDATE_TYPES; });
var DECREMENT_MAIN_COUNTER = 'DECREMENT_MAIN_COUNTER';
var INCREMENT_MAIN_COUNTER = 'INCREMENT_MAIN_COUNTER';

// Language
var UPDATE_LOCALE = 'UPDATE_LOCALE';

// Filters
var UPDATE_SEARCH = 'UPDATE_SEARCH';
var ADD_TYPE = 'ADD_GROUP';
var REMOVE_TYPE = 'REMOVE_GROUP';
var UPDATE_TYPES = 'UPDATE_TYPES';

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getEventById; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nquery getEventById($id: ID!, $userFilter: UserFilter) {\n  Event(id: $id) {\n    id\n    createdAt\n    name\n    initiator {\n      id\n      name\n    }\n    participants(orderBy: updatedAt_DESC) {\n      id\n      name\n      items {\n        id\n        name\n        quantity\n        unit\n        type\n      }\n      attendedEvents {\n        id\n      }\n    }\n    items(filter: {\n      user: $userFilter\n    }) {\n      id\n      name\n      quantity\n      unit\n      type\n    }\n  }\n}\n'], ['\nquery getEventById($id: ID!, $userFilter: UserFilter) {\n  Event(id: $id) {\n    id\n    createdAt\n    name\n    initiator {\n      id\n      name\n    }\n    participants(orderBy: updatedAt_DESC) {\n      id\n      name\n      items {\n        id\n        name\n        quantity\n        unit\n        type\n      }\n      attendedEvents {\n        id\n      }\n    }\n    items(filter: {\n      user: $userFilter\n    }) {\n      id\n      name\n      quantity\n      unit\n      type\n    }\n  }\n}\n']);



var getEventById = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_modules_language__ = __webpack_require__(48);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var messages = {
  en_US: __webpack_require__(106),
  fr_FR: __webpack_require__(107)
};

var dateTimeFormats = {
  'en-US': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'long', day: 'numeric'
    }
  },
  'fr-FR': {
    short: {
      year: 'numeric', month: 'short', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'long', day: 'numeric'
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: __WEBPACK_IMPORTED_MODULE_2__store_modules_language__["default"].state.locale,
  fallbackLocale: __WEBPACK_IMPORTED_MODULE_2__store_modules_language__["default"].state.fallbackLocale,
  messages: messages,
  dateTimeFormats: dateTimeFormats
}));

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_bus__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_headful__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_headful___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_headful__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LanguageSwitcher_vue__ = __webpack_require__(97);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_2__components_LanguageSwitcher_vue__["a" /* default */]
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__shared_bus__["a" /* bus */].$on('toast:new', function (toast) {
      return _this.addToast(toast);
    });

    __WEBPACK_IMPORTED_MODULE_1_headful___default()({
      title: 'Freatle - ' + this.$t('headTitle'),
      description: this.$t('headDescription')
    });
  },
  data: function data() {
    return {
      demoEventId: "cj644qgqlql7b01615i1ahqds",
      isNavbarOpen: false
    };
  },

  methods: {
    toggleNavbar: function toggleNavbar() {
      this.isNavbarOpen = !this.isNavbarOpen;
    },
    addToast: function addToast(toast) {
      if (!toast.message) {
        switch (toast.type) {
          case 'danger':
            toast.message = this.$t('genericError');
            break;
          case 'warning':
            toast.message = this.$t('genericWarning');
            break;
          default:
            toast.message = this.$t('genericError');
        }
      }

      var toastOptions = {
        message: toast.message,
        position: 'is-bottom'
      };

      if (toast.type) {
        toastOptions.type = 'is-' + toast.type;
      }

      this.$toast.open(toastOptions);
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'language-switcher',
  data: function data() {
    return {
      selected: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].locale,
      options: [{ text: 'English', value: 'en_US' }, { text: 'Français', value: 'fr_FR' }]
    };
  },

  methods: Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['changeLanguage'])
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vee_validate__ = __webpack_require__(51);




var getNavigatorLanguage = function getNavigatorLanguage() {
  console.log('navigator.language', window.navigator.language);
  var language = window.navigator.language.toLowerCase().replace('-', '_');

  switch (language) {
    case 'fr':
    case 'fr_fr':
      return 'fr_FR';
    default:
      return 'en_US';
  }
};

var state = {
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : getNavigatorLanguage(),
  fallbackLocale: 'en_US'
};

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* UPDATE_LOCALE */], function (state, payload) {
  state.locale = payload;
  __WEBPACK_IMPORTED_MODULE_2_vee_validate__["a" /* Validator */].localize(payload.substr(0, 2));
});

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_bus__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_smtpjs__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_smtpjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_smtpjs__);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation createEvent($eventName: String!, $initiatorName: String!, $initiatorEmail: String, $secret: String!) {\n    createEvent(name: $eventName) {\n      id\n      name\n    }\n    createUser(name: $initiatorName, email: $initiatorEmail, secret: $secret) {\n      id\n      name\n      email\n    }\n  }\n'], ['\n  mutation createEvent($eventName: String!, $initiatorName: String!, $initiatorEmail: String, $secret: String!) {\n    createEvent(name: $eventName) {\n      id\n      name\n    }\n    createUser(name: $initiatorName, email: $initiatorEmail, secret: $secret) {\n      id\n      name\n      email\n    }\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\nmutation addToUserInitiatedEvents($eventId: ID!, $userId: ID!) {\n  addToUserInitiatedEvents(initiatedEventsEventId: $eventId, initiatorUserId: $userId) {\n    initiatedEventsEvent {\n      id\n      name\n    }\n    initiatorUser {\n      id\n      name\n    }\n  }\n  addToEventParticipants(attendedEventsEventId: $eventId, participantsUserId: $userId) {\n    attendedEventsEvent {\n      id\n      name\n    }\n    participantsUser {\n      id\n      name\n    }\n  }\n}\n'], ['\nmutation addToUserInitiatedEvents($eventId: ID!, $userId: ID!) {\n  addToUserInitiatedEvents(initiatedEventsEventId: $eventId, initiatorUserId: $userId) {\n    initiatedEventsEvent {\n      id\n      name\n    }\n    initiatorUser {\n      id\n      name\n    }\n  }\n  addToEventParticipants(attendedEventsEventId: $eventId, participantsUserId: $userId) {\n    attendedEventsEvent {\n      id\n      name\n    }\n    participantsUser {\n      id\n      name\n    }\n  }\n}\n']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var uuidv4 = __webpack_require__(26);

var createEventAndUser = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);

var addToUserInitiatedEvents = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject2);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'create-event',
  data: function data() {
    return {
      step: 1,
      eventName: '',
      initiator: {
        name: '',
        email: '',
        secret: uuidv4()
      },
      isLoading: false
    };
  },

  methods: {
    sendMail: function sendMail(eventId, adminId) {
      if (this.initiator.email) {
        __WEBPACK_IMPORTED_MODULE_3_smtpjs___default.a.send('Freatle <freatle@pulsar.surge.sh>', this.initiator.email, this.$t('emailSubject', { eventName: this.eventName }), this.$t('emailBody', { eventId: eventId, eventName: this.eventName, adminId: adminId }), 'smtp.sendgrid.net', 'apikey', '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');
      }
    },
    nextStep: function nextStep() {
      this.step++;

      this.$ga && this.$ga.event('Event', 'click', 'nextStep');
    },
    finish: function finish() {
      var _this = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.$ga && _this.$ga.event('Event', 'click', 'create');

          _this.createEvent();
        } else {
          _this.$toast.open({
            message: _this.$t('fixErrors'),
            position: 'is-bottom',
            type: 'is-danger'
          });

          _this.$ga && _this.$ga.exception('Event:click:create');
        }
      });
    },
    getBack: function getBack() {
      this.step--;
    },
    createEvent: function createEvent() {
      var _this2 = this;

      this.isLoading = true;

      // Mutation
      this.$apollo.mutate({
        mutation: createEventAndUser,
        variables: {
          eventName: this.eventName,
          initiatorName: this.initiator.name,
          initiatorEmail: this.initiator.email,
          secret: this.initiator.secret
        }
      }).then(function (data) {
        var eventId = data.data.createEvent.id;

        // Bind the created event to the created user
        _this2.$apollo.mutate({
          mutation: addToUserInitiatedEvents,
          variables: {
            eventId: data.data.createEvent.id,
            userId: data.data.createUser.id
          }
        }).then(function (data) {
          _this2.$toast.open({
            message: _this2.$t('stepOne.eventCreated'),
            position: 'is-bottom',
            type: 'is-success'
          });

          localStorage.setItem('userId', data.data.addToUserInitiatedEvents.initiatorUser.id);

          _this2.sendMail(eventId, data.data.addToUserInitiatedEvents.initiatorUser.id);

          // Redirect the user to the event page
          _this2.$router.push({ name: 'Event', params: { id: data.data.addToUserInitiatedEvents.initiatedEventsEvent.id } });
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_2__shared_bus__["a" /* bus */].$emit('toast:new', { type: 'danger' });

          _this2.$ga && _this2.$ga.exception(error.message || error);
        }).then(function () {
          _this2.isLoading = false;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__shared_bus__["a" /* bus */].$emit('toast:new', { type: 'danger' });

        _this2.$ga && _this2.$ga.exception(error.message || error);

        _this2.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UserBox__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserForm__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_EventEditForm__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_queries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_EventFilters__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_EventInviteLink__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__EventMissing_vue__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n__ = __webpack_require__(24);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event',
  props: ['id'],
  components: {
    EventMissing: __WEBPACK_IMPORTED_MODULE_9__EventMissing_vue__["a" /* default */],
    EventInviteLink: __WEBPACK_IMPORTED_MODULE_8__components_EventInviteLink__["a" /* default */],
    EventFilters: __WEBPACK_IMPORTED_MODULE_6__components_EventFilters__["a" /* default */],
    UserBox: __WEBPACK_IMPORTED_MODULE_2__UserBox__["a" /* default */],
    UserForm: __WEBPACK_IMPORTED_MODULE_3__UserForm__["a" /* default */],
    EventEditForm: __WEBPACK_IMPORTED_MODULE_4__components_EventEditForm__["a" /* default */]
  },
  mounted: function mounted() {
    if (this.$route.query.admin) {
      localStorage.setItem('userId', this.$route.query.admin);
    }
  },
  data: function data() {
    return {
      event: null,
      demoEventId: "cj644qgqlql7b01615i1ahqds",
      isLoading: false,
      finishedLoading: false,
      showEditEventModal: false,
      isOpen: false,
      predefinedItemsList: {
        name: this.$t('itemsToBring'),
        items: []
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["c" /* mapState */])({
    searchFilter: function searchFilter(state) {
      return state.filters.search;
    }
  }), {
    isInitiator: function isInitiator() {
      return localStorage.getItem('userId') && localStorage.getItem('userId') === this.event.initiator.id;
    },
    localeForDate: function localeForDate() {
      return __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].locale.replace('_', '-');
    }
  }),
  watch: {
    isLoading: function isLoading(newValue) {
      newValue ? __WEBPACK_IMPORTED_MODULE_1_nprogress___default.a.start() : __WEBPACK_IMPORTED_MODULE_1_nprogress___default.a.done();
    }
  },
  apollo: {
    event: {
      query: __WEBPACK_IMPORTED_MODULE_5__shared_queries__["a" /* getEventById */],
      variables: function variables() {
        return {
          id: this.id,
          userFilter: null
        };
      },
      update: function update(data) {
        this.finishedLoading = true;
        console.log('Event', data.Event);
        this.predefinedItemsList.items = data.Event.items;
        return data.Event;
      },

      loadingKey: 'isLoading'
    }
  }
});

/***/ }),
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ItemList_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ItemListForm_vue__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UserNameForm_vue__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(16);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-box',
  props: {
    user: Object,
    event: Object
  },
  components: {
    ItemListForm: __WEBPACK_IMPORTED_MODULE_2__ItemListForm_vue__["a" /* default */],
    ItemList: __WEBPACK_IMPORTED_MODULE_1__ItemList_vue__["a" /* default */],
    UserNameForm: __WEBPACK_IMPORTED_MODULE_3__UserNameForm_vue__["a" /* default */]
  },
  data: function data() {
    return {
      showItemListForm: this.user.items.length === 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapState */])({
    typesFilter: function typesFilter(state) {
      return state.filters.types;
    }
  }), {
    isInitiator: function isInitiator() {
      return localStorage.getItem('userId') && localStorage.getItem('userId') === this.event.initiator.id;
    }
  }),
  methods: {
    addItem: function addItem() {
      this.showItemListForm = !this.showItemListForm;
      this.$ga && this.$ga.event('Items', 'click', 'add', 'First click');
    },
    cancelForm: function cancelForm() {
      this.showItemListForm = false;
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item_vue__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_mixins__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UserBoxForm__ = __webpack_require__(171);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'item-list',
  components: {
    UserBoxForm: __WEBPACK_IMPORTED_MODULE_6__components_UserBoxForm__["a" /* default */],
    Item: __WEBPACK_IMPORTED_MODULE_3__Item_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__shared_mixins__["a" /* globalMethods */]],
  props: {
    items: {
      type: Array,
      required: true
    },
    user: {
      type: Object,
      required: false
    },
    event: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return {
      showBrought: true,
      isPaginated: true,
      currentPage: 1,
      perPage: 5,
      checkedItems: []
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapState */])({
    typesFilter: function typesFilter(state) {
      return state.filters.types;
    }
  }), {
    filteredItems: function filteredItems() {
      var _this = this;

      return this.items.filter(function (item) {
        if (!_this.user.id && _this.isBrought(item) && !_this.showBrought) {
          return false;
        } else {
          return _this.typesFilter.length <= 0 || _this.typesFilter.includes(item.type);
        }
      });
    }
  }),
  methods: {
    isBrought: function isBrought(item) {
      var broughtItems = {};

      if (this.event.participants) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(this.event.participants), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var participant = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(participant.items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var userItem = _step2.value;

                if (broughtItems[userItem.name]) {
                  broughtItems[userItem.name].quantity += userItem.quantity;
                } else {
                  broughtItems[userItem.name] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, userItem);
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return !this.user.id && !!(broughtItems[item.name] && broughtItems[item.name].unit === item.unit && broughtItems[item.name].quantity >= item.quantity);
      } else {
        return false;
      }
    }
  }
});

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'item',
  props: ['item']
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return globalMethods; });
var globalMethods = {
  methods: {
    getTypeColor: function getTypeColor(type) {
      switch (type) {
        case 'SWEET':
          return 'is-success';
        case 'SAVORY':
          return 'is-danger';
        case 'MISCELLANEOUS':
          return 'is-dark';
        case 'ACCESSORY':
          return 'is-warning';
        case 'SOFT_DRINK':
          return 'is-info';
        case 'ALCOHOL':
          return 'is-primary';
        default:
          return 'is-dark';
      }
    }
  }
};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_queries__ = __webpack_require__(19);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation createUser($name: String!, $secret: String!, $attendedEventsIds: [ID!], $items: [UseritemsItem!]) {\n    createUser(name: $name, secret: $secret, attendedEventsIds: $attendedEventsIds, items: $items) {\n      id\n      name\n      items {\n        id\n        name\n        quantity\n        unit\n        type\n      }\n    }\n  }\n'], ['\n  mutation createUser($name: String!, $secret: String!, $attendedEventsIds: [ID!], $items: [UseritemsItem!]) {\n    createUser(name: $name, secret: $secret, attendedEventsIds: $attendedEventsIds, items: $items) {\n      id\n      name\n      items {\n        id\n        name\n        quantity\n        unit\n        type\n      }\n    }\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        mutation updateUser($userId: ID!, $items: [UseritemsItem!]) {\n          updateUser(id: $userId, items: $items) {\n            id\n            items {\n              id\n              name\n              quantity\n              unit\n              type\n            }\n          }\n          ', '\n        }\n      '], ['\n        mutation updateUser($userId: ID!, $items: [UseritemsItem!]) {\n          updateUser(id: $userId, items: $items) {\n            id\n            items {\n              id\n              name\n              quantity\n              unit\n              type\n            }\n          }\n          ', '\n        }\n      ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var uuidv4 = __webpack_require__(26);

var _createUser = __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-box-form',
  props: {
    items: {
      type: Array,
      required: true,
      default: []
    },
    event: {
      type: Object,
      required: false
    }
  },
  data: function data() {
    return {
      isLoading: false,
      keepFirst: true,
      name: '',
      selectedUser: null
    };
  },

  computed: {
    filteredParticipants: function filteredParticipants() {
      var _this = this;

      return this.event.participants.filter(function (option) {
        return option.name.toString().toLowerCase().indexOf(_this.name.toLowerCase()) >= 0;
      });
    }
  },
  methods: {
    bringItems: function bringItems() {
      this.isLoading = true;

      var userItems = [];
      var itemsToDeleteIds = [];
      var deleteQueries = '';

      if (this.selectedUser) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedUser.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            userItems.push({
              eventId: this.event.id,
              name: item.name,
              quantity: item.quantity,
              type: item.type,
              unit: item.unit
            });
          }

          // Delete
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.selectedUser.items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _item = _step2.value;

            itemsToDeleteIds.push(_item.id);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (itemsToDeleteIds.length > 0) {
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(itemsToDeleteIds), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var id = _step3.value;

              deleteQueries += id + ': deleteItem(id: "' + id + '") {id}';
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      }

      var itemsToAdd = userItems.slice();

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _item2 = _step4.value;

          itemsToAdd.push({
            eventId: this.event.id,
            name: _item2.name,
            quantity: _item2.quantity,
            type: _item2.type,
            unit: _item2.unit
          });
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      if (this.selectedUser) {
        this.updateUser(deleteQueries, this.selectedUser.id, this.event.id, itemsToAdd);
      } else {
        this.createUser(this.name, this.event.id, itemsToAdd);
      }
    },
    createUser: function createUser(userName, eventId, items) {
      var _this2 = this;

      // Mutation
      this.$apollo.mutate({
        mutation: _createUser,
        variables: {
          name: userName,
          secret: uuidv4(),
          attendedEventsIds: [eventId],
          items: items
        },
        refetchQueries: [{
          query: __WEBPACK_IMPORTED_MODULE_3__shared_queries__["a" /* getEventById */],
          variables: {
            id: eventId
          }
        }]
      }).then(function () {
        _this2.name = '';

        _this2.$toast.open({ message: _this2.$t('saveListSuccess'), position: 'is-bottom', type: 'is-success' });
      }).catch(function (error) {
        _this2.$ga && _this2.$ga.exception(error.message || error);

        _this2.$toast.open({ message: _this2.$t('saveListError'), position: 'is-bottom', type: 'is-danger' });
      }).then(function () {
        _this2.isLoading = false;
      });
    },
    updateUser: function updateUser(deleteQueries, userId, eventId, items) {
      var _this3 = this;

      var updateUser = __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject2, deleteQueries);

      // Mutation
      this.$apollo.mutate({
        mutation: updateUser,
        variables: {
          userId: userId,
          items: items
        },
        update: function update(store, _ref) {
          var data = _ref.data;

          var result = store.readQuery({ query: __WEBPACK_IMPORTED_MODULE_3__shared_queries__["a" /* getEventById */], variables: { id: eventId, userFilter: null } });

          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(result.Event.participants), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var participant = _step5.value;

              if (participant.id === userId) {
                participant.items = data.updateUser.items;
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }

          store.writeQuery({ query: __WEBPACK_IMPORTED_MODULE_3__shared_queries__["a" /* getEventById */], variables: { id: eventId, userFilter: null }, data: result });
        }
      }).then(function () {
        // Result
        _this3.$toast.open({ message: _this3.$t('saveListSuccess'), position: 'is-bottom', type: 'is-success' });
      }).catch(function (error) {
        // Error
        _this3.$ga && _this3.$ga.exception(error.message || error);

        _this3.$toast.open({ message: _this3.$t('saveListError'), position: 'is-bottom', type: 'is-danger' });
      }).then(function () {
        _this3.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_queries__ = __webpack_require__(19);




var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            mutation updateUser($userId: ID!, $items: [UseritemsItem!]) {\n              updateUser(id: $userId, items: $items) {\n                id\n                items {\n                  id\n                  name\n                  quantity\n                  unit\n                  type\n                }\n              }\n              ', '\n            }\n          '], ['\n            mutation updateUser($userId: ID!, $items: [UseritemsItem!]) {\n              updateUser(id: $userId, items: $items) {\n                id\n                items {\n                  id\n                  name\n                  quantity\n                  unit\n                  type\n                }\n              }\n              ', '\n            }\n          ']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n            mutation updateEvent($eventId: ID!, $items: [EventitemsItem!]) {\n              updateEvent(id: $eventId, items: $items) {\n                id\n                items {\n                  id\n                  name\n                  quantity\n                  unit\n                  type\n                }\n              }\n              ', '\n            }\n          '], ['\n            mutation updateEvent($eventId: ID!, $items: [EventitemsItem!]) {\n              updateEvent(id: $eventId, items: $items) {\n                id\n                items {\n                  id\n                  name\n                  quantity\n                  unit\n                  type\n                }\n              }\n              ', '\n            }\n          ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var uuidv4 = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'item-list-form',
  props: {
    onClose: {
      type: Function,
      required: true
    },
    eventId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: false
    },
    userItems: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      items: [],
      isLoading: false,
      demoEventId: "cj644qgqlql7b01615i1ahqds"
    };
  },
  mounted: function mounted() {
    var existingItems = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.userItems), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        var existingItem = {
          id: item.id,
          name: item.name,
          quantity: item.quantity ? item.quantity : 1,
          unit: item.unit,
          type: item.type
        };

        existingItems.push(existingItem);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    this.items = existingItems.concat(this.items);

    if (this.items.length <= 0) {
      this.addItem();
    }
  },

  methods: {
    addItem: function addItem() {
      this.items.push({ id: uuidv4(), name: '', quantity: 1, unit: 'Unit', type: 'MISCELLANEOUS' });
    },
    deleteItem: function deleteItem(id) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id && this.items[i].id === id) {
          this.items.splice(i, 1);
          break;
        }
      }
    },
    saveList: function saveList() {
      if (!this.isItemListUntouched()) {
        this.isLoading = true;

        var userId = this.userId;
        var eventId = this.eventId;
        var items = [];

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            var itemForUpdate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
            if (userId) {
              itemForUpdate.eventId = eventId;
            }
            itemForUpdate.quantity = +item.quantity;
            delete itemForUpdate.id;
            items.push(itemForUpdate);
          }

          // Delete
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        var itemsToDeleteIds = [];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.userItems), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _item = _step3.value;

            itemsToDeleteIds.push(_item.id);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        var deleteQueries = '';
        if (itemsToDeleteIds.length > 0) {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(itemsToDeleteIds), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var id = _step4.value;

              deleteQueries += id + ': deleteItem(id: "' + id + '") {id}';
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }

        if (!userId) {
          // If userId is undefined, it means we're updating the predefined items
          this.updateEvent(deleteQueries, eventId, items);
        } else {
          this.updateUser(deleteQueries, userId, eventId, items);
        }
      } else {
        this.$toast.open({ message: this.$t('itemListUntouched'), position: 'is-bottom', type: 'is-warning' });

        // The list items hasn't changed, so we close the form without sending a request
        this.onClose();
      }
    },
    closeForm: function closeForm() {
      this.onClose();
    },
    isDemoUser: function isDemoUser() {
      if (this.eventId === "cj644qgqlql7b01615i1ahqds") {
        if ("cj644re0lqwyd0161rmki4yn6 cj644qgqyql7d01616xh0d2nk".split(' ').includes(this.userId)) {
          return true;
        }
      }

      return false;
    },
    isItemListUntouched: function isItemListUntouched() {
      var _this = this;

      if (this.items.length === this.userItems.length) {
        return this.items.every(function (element, index) {
          return element.name === _this.userItems[index].name && element.quantity === _this.userItems[index].quantity && element.unit === _this.userItems[index].unit && element.type === _this.userItems[index].type;
        });
      } else {
        return false;
      }
    },
    validateBeforeSubmit: function validateBeforeSubmit() {
      var _this2 = this;

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this2.saveList();
          _this2.$ga && _this2.$ga.event('Items', 'click', 'add', 'Validate');
          return;
        }

        _this2.$toast.open({ message: _this2.$t('formInvalid'), position: 'is-bottom', type: 'is-danger' });
        _this2.$ga && _this2.$ga.exception('Items:click:add:Validate');
      });
    },
    updateUser: function updateUser(deleteQueries, userId, eventId, items) {
      var _this3 = this;

      var updateUser = __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject, deleteQueries);

      // Mutation
      this.$apollo.mutate({
        mutation: updateUser,
        variables: {
          userId: userId,
          items: items
        },
        update: function update(store, _ref) {
          var data = _ref.data;

          var result = store.readQuery({ query: __WEBPACK_IMPORTED_MODULE_4__shared_queries__["a" /* getEventById */], variables: { id: eventId, userFilter: null } });

          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(result.Event.participants), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var participant = _step5.value;

              if (participant.id === userId) {
                participant.items = data.updateUser.items;
              }
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }

          store.writeQuery({ query: __WEBPACK_IMPORTED_MODULE_4__shared_queries__["a" /* getEventById */], variables: { id: eventId, userFilter: null }, data: result });
        }
      }).then(function () {
        // Result
        _this3.$toast.open({ message: _this3.$t('saveListSuccess'), position: 'is-bottom', type: 'is-success' });

        _this3.onClose();
      }).catch(function (error) {
        // Error
        _this3.$ga && _this3.$ga.exception(error.message || error);

        _this3.$toast.open({ message: _this3.$t('saveListError'), position: 'is-bottom', type: 'is-danger' });
      }).then(function () {
        _this3.isLoading = false;
      });
    },
    updateEvent: function updateEvent(deleteQueries, eventId, items) {
      var _this4 = this;

      var updateEvent = __WEBPACK_IMPORTED_MODULE_3_graphql_tag___default()(_templateObject2, deleteQueries);

      // Mutation
      this.$apollo.mutate({
        mutation: updateEvent,
        variables: {
          eventId: eventId,
          items: items
        },
        update: function update(store, _ref2) {
          var data = _ref2.data;

          var result = store.readQuery({ query: __WEBPACK_IMPORTED_MODULE_4__shared_queries__["a" /* getEventById */], variables: { id: eventId, userFilter: null } });

          result.Event.items = data.updateEvent.items;

          store.writeQuery({ query: __WEBPACK_IMPORTED_MODULE_4__shared_queries__["a" /* getEventById */], variables: { id: eventId, userFilter: null }, data: result });
        }
      }).then(function () {
        // Result
        _this4.$toast.open({ message: _this4.$t('saveListSuccess'), position: 'is-bottom', type: 'is-success' });

        _this4.onClose();
      }).catch(function (error) {
        // Error
        _this4.$ga && _this4.$ga.exception(error.message || error);

        _this4.$toast.open({ message: _this4.$t('saveListError'), position: 'is-bottom', type: 'is-danger' });
      }).then(function () {
        _this4.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_queries__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_bus__ = __webpack_require__(23);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateUser($userId: ID!, $name: String!) {\n    updateUser(id: $userId, name: $name) {\n      id\n      name\n    }\n  }\n'], ['\n  mutation updateUser($userId: ID!, $name: String!) {\n    updateUser(id: $userId, name: $name) {\n      id\n      name\n    }\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        mutation deleteUser($userId: ID!) {\n          deleteUser(id: $userId) {\n            id\n          }\n          ', '\n        }\n      '], ['\n        mutation deleteUser($userId: ID!) {\n          deleteUser(id: $userId) {\n            id\n          }\n          ', '\n        }\n      ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var updateUser = __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-name-form',
  props: {
    user: {
      type: Object,
      required: true
    },
    event: {
      type: Object,
      required: true
    },
    isEditable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function data() {
    return {
      displayUserNameInput: false,
      userName: this.user.name,
      isLoading: false,
      showUserDeleteModal: false
    };
  },

  watch: {
    user: function user(newValue) {
      this.userName = newValue.name;
    }
  },
  methods: {
    editUser: function editUser() {
      this.displayUserNameInput = true;
    },
    hideUserUpdate: function hideUserUpdate() {
      this.displayUserNameInput = false;
    },
    updateUserName: function updateUserName() {
      var _this = this;

      this.isLoading = true;

      this.$apollo.mutate({
        mutation: updateUser,
        variables: {
          userId: this.user.id,
          name: this.userName
        }
      }).then(function () {
        _this.$toast.open({
          message: _this.$t('userUpdated'),
          position: 'is-bottom',
          type: 'is-success'
        });

        _this.displayUserNameInput = false;
      }).catch(function (error) {
        // Error
        __WEBPACK_IMPORTED_MODULE_4__shared_bus__["a" /* bus */].$emit('toast:new', { type: 'danger' });

        _this.$ga && _this.$ga.exception(error.message || error);
      }).then(function () {
        _this.isLoading = false;
      });
    },
    deleteUser: function deleteUser() {
      var _this2 = this;

      this.isLoading = true;

      // Delete
      var itemsToDeleteIds = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.user.items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          itemsToDeleteIds.push(item.id);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var deleteQueries = '';
      if (itemsToDeleteIds.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(itemsToDeleteIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var id = _step2.value;

            deleteQueries += id + ': deleteItem(id: "' + id + '") {id}';
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      var deleteUser = __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject2, deleteQueries);

      this.$apollo.mutate({
        mutation: deleteUser,
        variables: {
          userId: this.user.id
        },
        refetchQueries: [{
          query: __WEBPACK_IMPORTED_MODULE_3__shared_queries__["a" /* getEventById */],
          variables: {
            id: this.event.id
          }
        }]
      }).then(function () {
        // Result
        _this2.showUserDeleteModal = false;
        _this2.$toast.open({
          message: _this2.$t('deleteSuccess'),
          position: 'is-bottom',
          type: 'is-success'
        });
      }).catch(function (error) {
        // Error
        _this2.$ga && _this2.$ga.exception(error.message || error);
        __WEBPACK_IMPORTED_MODULE_4__shared_bus__["a" /* bus */].$emit('toast:new', { type: 'danger' });
      }).then(function () {
        _this2.isLoading = false;
      });
    },
    isDemoUser: function isDemoUser() {
      if (this.event.id === "cj644qgqlql7b01615i1ahqds") {
        if ("cj644re0lqwyd0161rmki4yn6 cj644qgqyql7d01616xh0d2nk".split(' ').includes(this.user.id)) {
          return true;
        }
      }

      return false;
    }
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_queries__ = __webpack_require__(19);


var _templateObject = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation createUser($name: String!, $secret: String!, $attendedEventsIds: [ID!]) {\n    createUser(name: $name, secret: $secret, attendedEventsIds: $attendedEventsIds) {\n      id\n      name\n    }\n  }\n'], ['\n  mutation createUser($name: String!, $secret: String!, $attendedEventsIds: [ID!]) {\n    createUser(name: $name, secret: $secret, attendedEventsIds: $attendedEventsIds) {\n      id\n      name\n    }\n  }\n']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var uuidv4 = __webpack_require__(26);

var createUser = __WEBPACK_IMPORTED_MODULE_1_graphql_tag___default()(_templateObject);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'user-form',
  data: function data() {
    return {
      userName: '',
      isLoading: false
    };
  },

  props: ['event-id'],
  methods: {
    addUser: function addUser() {
      var _this = this;

      this.isLoading = true;

      this.$apollo.mutate({
        mutation: createUser,
        variables: {
          name: this.userName,
          secret: uuidv4(),
          attendedEventsIds: [this.eventId]
        },
        refetchQueries: [{
          query: __WEBPACK_IMPORTED_MODULE_2__shared_queries__["a" /* getEventById */],
          variables: {
            id: this.eventId
          }
        }]
      }).then(function () {
        _this.userName = '';
      }).catch(function (error) {
        _this.$ga && _this.$ga.exception(error.message || error);
      }).then(function () {
        _this.isLoading = false;
      });
    }
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_tag__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_bus__ = __webpack_require__(23);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n  mutation updateEvent($eventId: ID!, $eventName: String!) {\n    updateEvent(id: $eventId, name: $eventName) {\n      id\n      name\n    }\n  }\n'], ['\n  mutation updateEvent($eventId: ID!, $eventName: String!) {\n    updateEvent(id: $eventId, name: $eventName) {\n      id\n      name\n    }\n  }\n']),
    _templateObject2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['\n        mutation deleteEvent($eventId: ID!) {\n          deleteEvent(id: $eventId) {\n            id\n          }\n          ', '\n          ', '\n        }\n      '], ['\n        mutation deleteEvent($eventId: ID!) {\n          deleteEvent(id: $eventId) {\n            id\n          }\n          ', '\n          ', '\n        }\n      ']);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _updateEvent = __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-edit-form',
  props: ['event', 'on-close'],
  data: function data() {
    return {
      eventName: this.event.name,
      isLoading: false,
      isUpdating: false,
      isDeleting: false
    };
  },

  methods: {
    updateEvent: function updateEvent() {
      var _this = this;

      this.isLoading = true;
      this.isUpdating = true;

      this.$apollo.mutate({
        mutation: _updateEvent,
        variables: {
          eventId: this.event.id,
          eventName: this.eventName
        }
      }).then(function () {
        __WEBPACK_IMPORTED_MODULE_3__shared_bus__["a" /* bus */].$emit('toast:new', { type: 'success', message: _this.$t('eventUpdated') });

        _this.onClose();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__shared_bus__["a" /* bus */].$emit('toast:new', { type: 'danger' });
        _this.$ga && _this.$ga.exception(error.message || error);
      }).then(function () {
        _this.isLoading = false;
        _this.isUpdating = false;
      });
    },
    deleteEvent: function deleteEvent() {
      var _this2 = this;

      this.isLoading = true;
      this.isDeleting = true;

      // Delete users
      var usersToDeleteIds = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.event.participants), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var participant = _step.value;

          if (participant.attendedEvents.length === 1 && participant.attendedEvents[0].id === this.event.id) {
            usersToDeleteIds.push(participant.id);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var deleteUserQueries = '';
      if (usersToDeleteIds.length > 0) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(usersToDeleteIds), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var id = _step2.value;

            deleteUserQueries += id + ': deleteUser(id: "' + id + '") {id}';
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      // Delete items
      var itemsToDeleteIds = [];
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.event.participants), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _participant = _step3.value;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_participant.items), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var item = _step5.value;

              itemsToDeleteIds.push(item.id);
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var deleteItemQueries = '';
      if (itemsToDeleteIds.length > 0) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(itemsToDeleteIds), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _id = _step4.value;

            deleteItemQueries += _id + ': deleteItem(id: "' + _id + '") {id}';
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }

      var deleteEvent = __WEBPACK_IMPORTED_MODULE_2_graphql_tag___default()(_templateObject2, deleteUserQueries, deleteItemQueries);

      this.$apollo.mutate({
        mutation: deleteEvent,
        variables: {
          eventId: this.event.id,
          userId: this.event.initiator.id
        }
      }).then(function () {
        _this2.$toast.open({
          message: _this2.$t('eventDeleted'),
          position: 'is-bottom',
          type: 'is-success'
        });

        _this2.$router.push({ name: 'CreateEvent' });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__shared_bus__["a" /* bus */].$emit('toast:new', { type: 'danger' });
        _this2.$ga && _this2.$ga.exception(error.message || error);
      }).then(function () {
        _this2.isLoading = false;
        _this2.isDeleting = false;
      });
    },
    isInitiator: function isInitiator() {
      return localStorage.getItem('userId') && localStorage.getItem('userId') === this.event.initiator.id;
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_mutation_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_mixins__ = __webpack_require__(70);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-filters',
  mixins: [__WEBPACK_IMPORTED_MODULE_1__shared_mixins__["a" /* globalMethods */]],
  data: function data() {
    return {
      types: ['SWEET', 'SAVORY', 'MISCELLANEOUS', 'ACCESSORY', 'SOFT_DRINK', 'ALCOHOL'],
      isOpen: false
    };
  },

  computed: {
    search: {
      get: function get() {
        return this.$store.state.filters.search;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["f" /* UPDATE_SEARCH */], value);
      }
    },
    typesFilter: {
      get: function get() {
        return this.$store.state.filters.types;
      },
      set: function set(value) {
        this.$store.commit(__WEBPACK_IMPORTED_MODULE_0__store_mutation_types__["g" /* UPDATE_TYPES */], value);
      }
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_clipboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_clipboard__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var location = window.location;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-invite-link',
  props: ['event-id'],
  mounted: function mounted() {
    var _this = this;

    var clipboard = new __WEBPACK_IMPORTED_MODULE_0_clipboard___default.a(this.$refs['copy-event-link-button']);
    clipboard.on('success', function () {
      _this.$toast.open({
        message: _this.$t('linkCopied'),
        position: 'is-bottom',
        type: 'is-info'
      });
    });
  },
  data: function data() {
    return {
      baseUrl: location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')
    };
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'event-missing'
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'help',
  data: function data() {
    return {
      name: '',
      email: '',
      message: ''
    };
  },

  computed: {
    isValidEmail: function isValidEmail() {
      var regex = new RegExp('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}');
      return regex.test(this.email);
    }
  },
  methods: {
    canSubmit: function canSubmit() {
      return this.name && this.isValidEmail && this.message;
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var files = __webpack_require__(214);
var modules = {};

files.keys().forEach(function (key) {
  if (key === './index.js') return;
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default;
});

/* harmony default export */ __webpack_exports__["default"] = (modules);

/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_buefy__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_apollo_client__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_apollo_link_http__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_apollo_cache_inmemory__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_apollo__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_analytics__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_fr__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_fr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_fr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__(51);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__webpack_require__(256);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_buefy___default.a, {
  defaultIconPack: 'fa',
  defaultNoticeQueue: false
});

// Paste your endpoint for the Simple API here.
// Info: https://github.com/graphcool-examples/vue-apollo-instagram-example#2-create-graphql-api-with-graphcool
var httpLink = new __WEBPACK_IMPORTED_MODULE_7_apollo_link_http__["a" /* HttpLink */]({
  uri: 'https://api.graph.cool/simple/v1/cj63wpfe4hjmq0160xyp9v449'
});

var apolloClient = new __WEBPACK_IMPORTED_MODULE_6_apollo_client__["a" /* ApolloClient */]({
  link: httpLink,
  cache: new __WEBPACK_IMPORTED_MODULE_8_apollo_cache_inmemory__["a" /* InMemoryCache */](),
  connectToDevTools: true
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_apollo__["a" /* default */]);

// Install the vue plugin
var apolloProvider = new __WEBPACK_IMPORTED_MODULE_9_vue_apollo__["a" /* default */]({
  defaultClient: apolloClient
});

// Google Analytics
if (true) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_analytics___default.a, {
    id: 'UA-99632110-2',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    autoTracking: {
      exception: true
    }
  });
}

__WEBPACK_IMPORTED_MODULE_12_vee_validate__["a" /* Validator */].localize('fr', __WEBPACK_IMPORTED_MODULE_11_vee_validate_dist_locale_fr___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["b" /* default */], {
  locale: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.language.locale.substr(0, 2),
  dictionary: {
    en: {
      attributes: {
        itemName: '"What"',
        itemQuantity: '"Quantity"'
      }
    },
    fr: {
      attributes: {
        itemName: '"Quoi"',
        itemQuantity: '"Quantité"'
      }
    }
  }
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */],
  apolloProvider: apolloProvider,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 92 */,
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_115ad8bd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(109);
function injectStyle (ssrContext) {
  __webpack_require__(94)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_115ad8bd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(111)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageSwitcher_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebcfc5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSwitcher_vue__ = __webpack_require__(108);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageSwitcher_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ebcfc5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSwitcher_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, exports) {

module.exports = {"item":{"name":"What","nameExtended":"Smoothie, peanuts, sleeping bag...","quantity":"Quantity","quantityExtended":"Quantity","unit":"Unit","type":"Type"},"units":{"Unit":"Unit(s)","KG":"Kg","L":"L"},"types":{"SWEET":"Sweet","SAVORY":"Savory","MISCELLANEOUS":"Miscellaneous","ACCESSORY":"Accessory","SOFT_DRINK":"Soft drink","ALCOHOL":"Alcohol"},"by":"by","edit":"Edit","filters":"Search filters","filterByParticipants":"Filter by participants","filterByTypes":"Filter by types","emptyItemList":"Nothing to display! Bring some stuff by clicking on <strong>Add items</strong> or <strong>Manage items</strong>.","thisField":"This field","loading":"Loading...","isPaginated":"Paginated","showBrought":"Show already brought items","selectedItems":"selected item(s)","addPredefinedItems":"Add a list of things to bring","itemsToBring":"Items to bring","validate":"Validate","cancel":"Cancel","saveListSuccess":"The item list has been updated successfully.","saveListError":"An error has occurred. Check that you have correctly filled all fields (they are all mandatory).","itemListUntouched":"Your item list hasn't changed, so we didn't issue a request to our servers.","formInvalid":"Your input does not seem correct. Check that you have correctly filled all required fields."}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = {"item":{"name":"Quoi","nameExtended":"Smoothie, cacahuètes, sac de couchage...","quantity":"Quantité","quantityExtended":"Combien ?","unit":"Unité","type":"Catégorie"},"units":{"Unit":"Pièce(s)","KG":"Kg","L":"L"},"types":{"SWEET":"Sucré","SAVORY":"Salé","MISCELLANEOUS":"Divers","ACCESSORY":"Équipement","SOFT_DRINK":"Boisson soft","ALCOHOL":"Alcool"},"by":"par","edit":"Modifier","filters":"Filtres de recherche","filterByParticipants":"Filtrer par participants","filterByTypes":"Filtrer par types","emptyItemList":"Rien à afficher ! Ajoutez des trucs en cliquant sur <strong>Ajouter des items</strong> ou <strong>Gérer les items</strong>.","thisField":"Ce champ","loading":"En chargement...","isPaginated":"Pagination","showBrought":"Montrer les items déjà rapportés","selectedItems":"item(s) sélectionnés","addPredefinedItems":"Ajouter une liste de choses à rapporter","itemsToBring":"Items à rapporter","validate":"Valider","cancel":"Annuler","saveListSuccess":"La liste d'items a été enregistrée avec succès.","saveListError":"Une erreur s'est produite. Vérifiez que vous avez bien complété tous les champs (ils sont tous requis).","itemListUntouched":"Votre liste d'items n'a pas changé. Nous n'avons pas envoyé de requête à nos serveurs.","formInvalid":"Votre saisie ne semble pas correcte. Vérifiez que vous avez bien complété tous les champs requis."}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[_c('div',{staticClass:"control has-icons-left"},[_c('div',{staticClass:"select"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticClass:"form-control",attrs:{"id":"languageSelect"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function (e) { return _vm.changeLanguage(e.target.value); }]}},_vm._l((_vm.options),function(option){return _c('option',{domProps:{"value":option.value}},[_vm._v(_vm._s(option.text))])}))]),_vm._v(" "),_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-globe"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"navbar has-shadow"},[_c('div',{staticClass:"navbar-brand"},[_c('router-link',{staticClass:"navbar-item",attrs:{"to":"/","exact":""}},[_c('img',{attrs:{"src":__webpack_require__(110),"alt":"Freatle","width":"112","height":"28"}})]),_vm._v(" "),_c('div',{staticClass:"navbar-burger burger",class:{ 'is-active': _vm.isNavbarOpen },on:{"click":_vm.toggleNavbar}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])],1),_vm._v(" "),_c('div',{staticClass:"navbar-menu",class:{ 'is-active': _vm.isNavbarOpen }},[_c('div',{staticClass:"navbar-start"},[_c('router-link',{staticClass:"navbar-item is-tab",attrs:{"to":"/","exact":""}},[_vm._v(_vm._s(_vm.$t('home')))]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item is-tab",attrs:{"to":'/event/' + _vm.demoEventId,"exact":""}},[_vm._v(_vm._s(_vm.$t('demo')))]),_vm._v(" "),_c('router-link',{staticClass:"navbar-item is-tab",attrs:{"to":"/help","exact":""}},[_vm._v(_vm._s(_vm.$t('help')))])],1),_vm._v(" "),_c('div',{staticClass:"navbar-end"},[_c('div',{staticClass:"navbar-item"},[_c('div',{staticClass:"field is-grouped is-grouped-multiline"},[_c('p',{staticClass:"control"},[_c('a',{staticClass:"button is-primary is-outlined",attrs:{"href":"https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=RA8SPLMLG97DL","target":"_blank","rel":"noopener"}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('donate')))])])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('language-switcher')],1)])])])])]),_vm._v(" "),_c('section',{staticClass:"hero is-danger"},[_c('div',{staticClass:"hero-body",staticStyle:{"padding-top":"8px","padding-bottom":"8px"}},[_c('div',{staticClass:"container has-text-centered"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('notice'))}})])])]),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"content has-text-centered"},[_c('p',[_c('strong',[_vm._v("Freatle")]),_vm._v(" "+_vm._s(_vm.$t('by'))+" "),_c('a',{attrs:{"href":"https://pulsar.surge.sh/"}},[_vm._v("Pulsar")]),_vm._v(". "+_vm._s(_vm.$t('copyright'))+".\n        ")]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"content has-text-centered"},[_c('a',{staticClass:"button is-info is-small",attrs:{"href":"https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Ffreatle.com%2F","target":"_blank","aria-label":"Share on Facebook"}},[_c('b-icon',{attrs:{"pack":"fa","icon":"facebook","size":"is-small"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('shareFacebook')))])],1),_vm._v(" "),_c('a',{staticClass:"button is-primary is-small",attrs:{"href":"https://twitter.com/intent/tweet/?text=Freatle%20-%20Qui%20ram%C3%A8ne%20quoi%20%3F&url=https%3A%2F%2Ffreatle.com%2F","target":"_blank","aria-label":"Share on Twitter"}},[_c('b-icon',{attrs:{"pack":"fa","icon":"twitter","size":"is-small"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('shareTwitter')))])],1)])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-paypal"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('a',{attrs:{"href":"https://github.com/pulsardev"}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-lg fa-github"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"home":"Home","demo":"Sample event","by":"by","copyright":"All rights reserved","donate":"Donate","help":"Help","headTitle":"Who brings what?","headDescription":"The simplest to know who brings what.","shareFacebook":"Share on Facebook","shareTwitter":"Share on Twitter","notice":"Freatle is evolving ! Events created on this version will be accessible until 30/06/2020. Please create new events on the new version: <a href=\u0027https://freatle.com\u0027>https://freatle.com</a>."},"fr_FR":{"home":"Accueil","demo":"Exemple d\u0027événement","by":"par","copyright":"Tous droits réservés","donate":"Faire un don","help":"Aide","headTitle":"Qui ramène quoi ?","headDescription":"Le plus simple pour savoir qui ramène quoi.","shareFacebook":"Partager sur Facebook","shareTwitter":"Partager sur Twitter","notice":"Freatle évolue ! Les évènements créés sur cette version ne seront plus visibles après le 30/06/2020. Veuillez créer tout nouvel évènement sur la nouvelle version : <a href=\u0027https://freatle.com\u0027>https://freatle.com</a>."}}')
}


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CreateEvent__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Event__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Help__ = __webpack_require__(207);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [{
    path: '/',
    name: 'CreateEvent',
    component: __WEBPACK_IMPORTED_MODULE_2__components_CreateEvent__["a" /* default */]
  }, {
    path: '/event/:id',
    name: 'Event',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Event__["a" /* default */],
    props: true
  }, {
    path: '/help',
    name: 'Help',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Help__["a" /* default */]
  }, {
    path: '*',
    redirect: {
      name: 'CreateEvent'
    }
  }]
}));

/***/ }),
/* 113 */,
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateEvent_vue__ = __webpack_require__(52);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d23dcc60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateEvent_vue__ = __webpack_require__(139);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateEvent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d23dcc60_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CreateEvent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(140)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */
/***/ (function(module, exports) {

module.exports = Email;

/***/ }),
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-event"},[(_vm.step === 1)?_c('section',{staticClass:"hero is-medium is-warning c-background--image"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('h1',{staticClass:"title is-2 c-heading__title"},[_vm._v(_vm._s(_vm.$t('stepOne.title')))]),_vm._v(" "),_c('h2',{staticClass:"subtitle is-4 c-heading__subtitle"},[_vm._v(_vm._s(_vm.$t('stepOne.subtitle')))]),_vm._v(" "),_c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column is-half-tablet is-offset-one-quarter-tablet"},[_c('div',{staticClass:"field is-grouped is-grouped-centered is-grouped-multiline"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventName),expression:"eventName"}],staticClass:"input is-medium",attrs:{"placeholder":_vm.$t('stepOne.eventName')},domProps:{"value":(_vm.eventName)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.nextStep()},"input":function($event){if($event.target.composing){ return; }_vm.eventName=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-medium is-primary",attrs:{"disabled":""},on:{"click":function($event){_vm.nextStep()}}},[_vm._v("\n                  "+_vm._s(_vm.$t('stepOne.create'))+"\n                ")])])])])])])])]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('section',{staticClass:"hero is-warning c-background--image"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('h2',{staticClass:"subtitle is-5 c-heading__subtitle"},[_vm._v(_vm._s(_vm.$t('stepTwo.step', {current: 2, total: 2})))]),_vm._v(" "),_c('h1',{staticClass:"title is-3 c-heading__title"},[_vm._v(_vm._s(_vm.$t('stepTwo.userNameLabel')))]),_vm._v(" "),_c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column is-half-tablet is-offset-one-quarter-tablet"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.initiator.name),expression:"initiator.name"}],staticClass:"input",attrs:{"placeholder":_vm.$t('stepTwo.name'),"required":""},domProps:{"value":(_vm.initiator.name)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.finish()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.initiator, "name", $event.target.value)}}}),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control is-expanded has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.initiator.email),expression:"initiator.email"},{name:"validate",rawName:"v-validate",value:('email'),expression:"'email'"}],staticClass:"input",class:{'is-danger': _vm.errors.has('email') },attrs:{"name":"email","data-vv-as":"'Email'","type":"text","placeholder":'Email (' + _vm.$t('optional') + ')'},domProps:{"value":(_vm.initiator.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.initiator, "email", $event.target.value)}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('email')))])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('b-tooltip',{attrs:{"label":_vm.$t('stepTwo.emailInfo'),"position":"is-left","type":"is-dark","multilined":""}},[_c('a',{staticClass:"button"},[_c('span',{staticClass:"icon is-right has-text-info"},[_c('i',{staticClass:"fa fa-info-circle"})])])])],1)])])]),_vm._v(" "),_c('footer',{staticClass:"card-footer"},[_c('a',{staticClass:"card-footer-item",on:{"click":function($event){_vm.getBack()}}},[_vm._v(_vm._s(_vm.$t('stepTwo.previous')))]),_vm._v(" "),_c('div',{staticClass:"card-footer-item"},[_c('button',{staticClass:"button is-medium is-primary",class:{ 'is-loading': _vm.isLoading },attrs:{"disabled":_vm.initiator.name.trim() === '' || _vm.isLoading},on:{"click":function($event){_vm.finish()}}},[_vm._v(_vm._s(_vm.$t('stepTwo.finish')))])])])])])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-user-circle"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-envelope"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 140 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"stepOne":{"title":"Organize your event with Freatle","subtitle":"The simplest to know who brings what.","eventName":"On which occasion?","create":"Create a list","eventCreated":"The event has been created successfully."},"stepTwo":{"step":"Step {current} of {total}","userNameLabel":"Tell your participants who you are","name":"Name","emailInfo":"This field is not required. It will allow us to send you the link of your event so you can find it easily.","previous":"Previous","finish":"Finish"},"fixErrors":"Fix the errors to continue.","emailSubject":"Your event \\"{eventName}\\" is ready!","emailBody":"<p>You can see it or share it by using this link:<br><a href=\\"https://freatle.com/event/{eventId}\\">https://freatle.com/event/{eventId}</a></p><p>You can also edit it by using this link:<br><a href=\\"https://freatle.com/event/{eventId}?admin={adminId}\\">https://freatle.com/event/{eventId}?admin={adminId}</a><br>Please note that this is your administration link, don\u0027t share it unless you want people you invite to have full control over the event.</p><p>Thanks for using Freatle! If you have some feedback for us, feel free to <a href=\\"mailto:pulsar.dev.team@gmail.com\\">contact us</a>.</p>","optional":"optional"},"fr_FR":{"stepOne":{"title":"Organisez-vous avec Freatle","subtitle":"Le plus simple pour savoir qui ramène quoi.","eventName":"Pour quelle occasion ?","create":"Créer une liste","eventCreated":"Événement créé avec succès."},"stepTwo":{"step":"Étape {current} sur {total}","userNameLabel":"Dites à vos participants qui vous êtes","name":"Nom","emailInfo":"Ce champ est optionnel. Il nous servira à vous envoyer le lien de votre évènement afin que vous puissiez le retrouver facilement.","previous":"Précédent","finish":"Terminer"},"fixErrors":"Corrigez les erreurs pour continuer.","emailSubject":"Votre évènement \\"{eventName}\\" est prêt !","emailBody":"<p>Vous pouvez y accéder et le partager en utilisant ce lien :<br><a href=\\"https://freatle.com/event/{eventId}\\">https://freatle.com/event/{eventId}</a></p><p>Vous pouvez également l\u0027éditer en utilisant ce lien :<br><a href=\\"https://freatle.com/event/{eventId}?admin={adminId}\\">https://freatle.com/event/{eventId}?admin={adminId}</a><br>Veuillez noter que ceci est votre lien d\u0027administration, ne le partagez pas sauf si vous voulez que vos invités puissent éditer complètement votre évènement.</p><p>Merci d\u0027utiliser Freatle ! Si vous avez des retours à nous faire, n\u0027hésitez pas à <a href=\\"mailto:pulsar.dev.team@gmail.com\\">nous contacter</a>.</p>","optional":"optionnel"}}')
}


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da82e9ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__ = __webpack_require__(206);
function injectStyle (ssrContext) {
  __webpack_require__(142)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-da82e9ee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Event_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_da82e9ee_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Event_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBox_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3090ca68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBox_vue__ = __webpack_require__(182);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3090ca68_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(183)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemList_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea6e19a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemList_vue__ = __webpack_require__(174);
function injectStyle (ssrContext) {
  __webpack_require__(151)
  __webpack_require__(152)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea6e19a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea6e19a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__ = __webpack_require__(69);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9fe7a98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__ = __webpack_require__(170);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Item_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9fe7a98_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Item_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"level is-marginless"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.item.name))])])])]),_vm._v(" "),_c('div',{staticClass:"level-right"},[_c('div',{staticClass:"level-item"},[_c('p',[_c('small',[_vm._v(_vm._s(_vm.item.quantity))])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBoxForm_vue__ = __webpack_require__(71);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629f03fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBoxForm_vue__ = __webpack_require__(173);
function injectStyle (ssrContext) {
  __webpack_require__(172)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-629f03fc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserBoxForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_629f03fc_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserBoxForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field is-grouped is-grouped-multiline"},[_c('b-autocomplete',{staticClass:"is-expanded",attrs:{"placeholder":"Entrez votre nom","keep-first":_vm.keepFirst,"data":_vm.filteredParticipants,"field":"name"},on:{"select":function (option) { return _vm.selectedUser = option; }},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n      "+_vm._s(props.option.name)+" "),_c('span',{staticClass:"is-pulled-right"},[_c('strong',[_vm._v(_vm._s(props.option.items.length))]),_vm._v(" item(s)")])]}}]),model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-info",class:{ 'is-loading': _vm.isLoading },on:{"click":_vm.bringItems}},[_vm._v("Je ramène les items choisis")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[(!_vm.user.id)?_c('b-field',{attrs:{"grouped":"","group-multiline":"","position":"is-right"}},[_c('div',{staticClass:"control is-flex"},[_c('b-switch',{attrs:{"size":"is-small"},model:{value:(_vm.isPaginated),callback:function ($$v) {_vm.isPaginated=$$v},expression:"isPaginated"}},[_vm._v(_vm._s(_vm.$t('isPaginated')))])],1),_vm._v(" "),_c('div',{staticClass:"control is-flex"},[_c('b-switch',{attrs:{"size":"is-small"},model:{value:(_vm.showBrought),callback:function ($$v) {_vm.showBrought=$$v},expression:"showBrought"}},[_vm._v(_vm._s(_vm.$t('showBrought')))])],1)]):_vm._e(),_vm._v(" "),(_vm.filteredItems.length === 0)?_c('div',{staticClass:"section"},[_c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('emptyItemList'))}})])]):_c('b-table',{attrs:{"data":_vm.filteredItems.length === 0 ? [] : _vm.filteredItems,"striped":true,"mobile-cards":true,"default-sort":"name","checked-rows":_vm.checkedItems,"checkable":!_vm.user.id && _vm.filteredItems.length > 0,"paginated":_vm.isPaginated && !_vm.user.id,"per-page":_vm.perPage,"current-page":_vm.currentPage},on:{"update:checkedRows":function($event){_vm.checkedItems=$event},"update:currentPage":function($event){_vm.currentPage=$event}},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"name","label":_vm.$t('item.name'),"sortable":""}},[_c('span',{class:{ 'is-strikethrough': _vm.isBrought(props.row) }},[_vm._v(_vm._s(props.row.name))])]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"quantity","label":_vm.$t('item.quantity'),"sortable":"","numeric":""}},[_vm._v("\n            "+_vm._s(props.row.quantity)+" "+_vm._s(_vm.$t('units.' + props.row.unit))+"\n          ")]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"type","label":_vm.$t('item.type')}},[_c('b-tag',{attrs:{"type":_vm.getTypeColor(props.row.type)}},[_vm._v(_vm._s(_vm.$t('types.' + props.row.type)))])],1)]}}])},[_c('template',{slot:"empty"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('emptyItemList'))}})])])]),_vm._v(" "),(_vm.filteredItems.length > 0)?_c('template',{slot:"bottom-left"},[_c('strong',[_vm._v(_vm._s(_vm.checkedItems.length))]),_vm._v(" "+_vm._s(_vm.$t('selectedItems'))+"\n        ")]):_vm._e()],2)],1)]),_vm._v(" "),(!_vm.user.id && _vm.checkedItems.length > 0)?_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('user-box-form',{attrs:{"event":_vm.event,"items":_vm.checkedItems}})],1)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemListForm_vue__ = __webpack_require__(72);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685e0f27_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemListForm_vue__ = __webpack_require__(177);
function injectStyle (ssrContext) {
  __webpack_require__(176)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-685e0f27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ItemListForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_685e0f27_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ItemListForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 176 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('article',{staticClass:"media"},[_c('div',{staticClass:"media-content"},[(_vm.items.length > 0)?_c('div',{staticClass:"content"},[_c('b-table',{attrs:{"data":_vm.items.length === 0 ? [] : _vm.items,"striped":true,"mobile-cards":true,"default-sort":"name"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"field":"name","label":_vm.$t('item.name'),"sortable":""}},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(props.row.name),expression:"props.row.name"}],staticClass:"input is-small",attrs:{"name":"itemName","type":"text","placeholder":_vm.$t('item.nameExtended')},domProps:{"value":(props.row.name)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.validateBeforeSubmit($event)},"input":function($event){if($event.target.composing){ return; }_vm.$set(props.row, "name", $event.target.value)}}})])])]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"quantity","label":_vm.$t('item.quantity'),"numeric":""}},[_c('div',{staticClass:"field is-grouped"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required|min_value:0.001|decimal:3'),expression:"'required|min_value:0.001|decimal:3'"},{name:"model",rawName:"v-model",value:(props.row.quantity),expression:"props.row.quantity"}],staticClass:"input is-small",attrs:{"name":"itemQuantity","size":"5","placeholder":_vm.$t('item.quantityExtended')},domProps:{"value":(props.row.quantity)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(props.row, "quantity", $event.target.value)}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('span',{staticClass:"select is-small"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(props.row.unit),expression:"props.row.unit"}],attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(props.row, "unit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Unité...")]),_vm._v(" "),_c('option',{attrs:{"value":"Unit"}},[_vm._v(_vm._s(_vm.$t('units.Unit')))]),_vm._v(" "),_c('option',{attrs:{"value":"KG"}},[_vm._v(_vm._s(_vm.$t('units.KG')))]),_vm._v(" "),_c('option',{attrs:{"value":"L"}},[_vm._v(_vm._s(_vm.$t('units.L')))])])])])])]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"type","label":_vm.$t('item.type')}},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control"},[_c('span',{staticClass:"select is-small"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(props.row.type),expression:"props.row.type"}],attrs:{"required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(props.row, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Catégorie...")]),_vm._v(" "),_c('option',{attrs:{"value":"SWEET"}},[_vm._v(_vm._s(_vm.$t('types.SWEET')))]),_vm._v(" "),_c('option',{attrs:{"value":"SAVORY"}},[_vm._v(_vm._s(_vm.$t('types.SAVORY')))]),_vm._v(" "),_c('option',{attrs:{"value":"MISCELLANEOUS"}},[_vm._v(_vm._s(_vm.$t('types.MISCELLANEOUS')))]),_vm._v(" "),_c('option',{attrs:{"value":"ACCESSORY"}},[_vm._v(_vm._s(_vm.$t('types.ACCESSORY')))]),_vm._v(" "),_c('option',{attrs:{"value":"SOFT_DRINK"}},[_vm._v(_vm._s(_vm.$t('types.SOFT_DRINK')))]),_vm._v(" "),_c('option',{attrs:{"value":"ALCOHOL"}},[_vm._v(_vm._s(_vm.$t('types.ALCOHOL')))])])])])])]),_vm._v(" "),_c('b-table-column',{attrs:{"field":"id"}},[_c('a',{staticClass:"button is-small is-rounded is-danger is-outlined",on:{"click":function($event){_vm.deleteItem(props.row.id)}}},[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-times"})])])])]}}])}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('itemName')),expression:"errors.has('itemName')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('itemName')))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('itemQuantity')),expression:"errors.has('itemQuantity')"}],staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.errors.first('itemQuantity')))])],1):_vm._e(),_vm._v(" "),_c('nav',[_c('div',{staticClass:"field is-grouped is-grouped-multiline is-pulled-right"},[_c('p',{staticClass:"control"},[_c('a',{staticClass:"button is-rounded is-success",on:{"click":_vm.addItem}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v("Item")])])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",class:{ 'is-loading': _vm.isLoading },attrs:{"disabled":_vm.isLoading || _vm.isDemoUser()},on:{"click":_vm.validateBeforeSubmit}},[_vm._m(1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('validate')))])])]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-danger",on:{"click":_vm.closeForm}},[_c('span',[_vm._v(_vm._s(_vm.$t('cancel')))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-plus"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-check"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserNameForm_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_272e2b3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserNameForm_vue__ = __webpack_require__(180);
function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-272e2b3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserNameForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_272e2b3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserNameForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(181)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEditable)?_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"title is-4 c-username c-username--truncated",attrs:{"title":_vm.user.name}},[_vm._v(_vm._s(_vm.user.name))])])]):_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[(!_vm.displayUserNameInput)?_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('p',{staticClass:"title is-4 c-username c-username--truncated",attrs:{"title":_vm.user.name}},[_vm._v(_vm._s(_vm.user.name))])]),_vm._v(" "),_c('div',{staticClass:"level-item"},[_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control"},[_c('button',{staticClass:"button",attrs:{"disabled":_vm.isDemoUser()},on:{"click":_vm.editUser}},[_vm._m(0)])]),_vm._v(" "),(_vm.user.id !== _vm.event.initiator.id)?_c('p',{staticClass:"control"},[_c('button',{staticClass:"button",class:{ 'is-loading': _vm.isLoading },attrs:{"disabled":_vm.isLoading || _vm.isDemoUser()},on:{"click":function($event){_vm.showUserDeleteModal = true}}},[_vm._m(1)])]):_vm._e()])])])]):_vm._e(),_vm._v(" "),(_vm.displayUserNameInput)?_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('div',{staticClass:"field"},[_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],staticClass:"input is-medium",attrs:{"size":"20","placeholder":_vm.$t('userName')},domProps:{"value":(_vm.userName)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.updateUserName($event)},"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"level-item"},[_c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",class:{ 'is-loading': _vm.isLoading },attrs:{"disabled":_vm.userName.trim() === '' || _vm.isLoading},on:{"click":_vm.updateUserName}},[_vm._m(2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('validate')))])])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",on:{"click":_vm.hideUserUpdate}},[_c('span',[_vm._v(_vm._s(_vm.$t('cancel')))])])])])])])]):_vm._e()]),_vm._v(" "),(_vm.user.id === _vm.event.initiator.id)?_c('div',{staticClass:"level-item"},[_c('span',{staticClass:"tag is-info is-medium"},[_vm._v(_vm._s(_vm.$t('host')))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"modal",class:{ 'is-active': _vm.showUserDeleteModal }},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.showUserDeleteModal = false}}}),_vm._v(" "),_c('div',{staticClass:"modal-card has-text-left"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.$t('deleteModalTitle')))]),_vm._v(" "),_c('button',{staticClass:"delete",on:{"click":function($event){_vm.showUserDeleteModal = false}}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_vm._v("\n        "+_vm._s(_vm.$t('deleteModalText', {userName: _vm.user.name}))+"\n      ")]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"button is-success",on:{"click":function($event){_vm.showUserDeleteModal = false}}},[_vm._v(_vm._s(_vm.$t('deleteModalBackButton')))]),_vm._v(" "),_c('button',{staticClass:"button is-danger",class:{ 'is-loading': _vm.isLoading },attrs:{"disabled":_vm.isLoading},on:{"click":_vm.deleteUser}},[_vm._m(3),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('deleteModalDeleteButton')))])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-pencil"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-times"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-check"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-exclamation-triangle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"userName":"User name","validate":"Validate","cancel":"Cancel","host":"Host","deleteModalTitle":"Delete this participant","deleteModalText":"You are going to permanently delete this participant: {userName}.","deleteModalBackButton":"I don\u0027t think so, it\u0027s not a good idea","deleteModalDeleteButton":"Come on! Let\u0027s do it!","deleteSuccess":"The participant has been deleted successfully.","userUpdated":"The user has been updated successfully."},"fr_FR":{"userName":"Nom","validate":"Valider","cancel":"Annuler","host":"Hôte","deleteModalTitle":"Supprimer ce participant","deleteModalText":"Vous allez supprimer définitivement ce participant : {userName}.","deleteModalBackButton":"Finalement non, ce n\u0027est pas une bonne idée","deleteModalDeleteButton":"Allez, soyons fou !","deleteSuccess":"L\u0027utilisateur a été supprimé avec succès.","userUpdated":"L\u0027utilisateur a été mis à jour avec succès."}}')
}


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",staticStyle:{"background-color":"whitesmoke"}},[_c('div',{staticClass:"level"},[_c('user-name-form',{attrs:{"user":_vm.user,"event":_vm.event,"is-editable":!!_vm.user.id}}),_vm._v(" "),(!!_vm.user.id || (!_vm.user.id && _vm.isInitiator))?_c('div',{staticClass:"level-right"},[_c('div',{staticClass:"level-item"},[_c('button',{staticClass:"button is-primary",on:{"click":_vm.addItem}},[_c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa",class:[_vm.user.items.length <= 0 ? 'fa-plus' : 'fa-pencil']})]),_vm._v(" "),(_vm.user.items.length <= 0)?_c('span',[_vm._v(_vm._s(_vm.$t('addItems')))]):_c('span',[_vm._v(_vm._s(_vm.$t('manageItems')))])])])]):_vm._e()],1),_vm._v(" "),(_vm.showItemListForm)?_c('item-list-form',{attrs:{"on-close":_vm.cancelForm,"event-id":_vm.event.id,"user-id":_vm.user.id,"user-items":_vm.user.items}}):_vm._e(),_vm._v(" "),(!_vm.showItemListForm)?_c('item-list',{attrs:{"items":_vm.user.items,"user":_vm.user,"event":_vm.event}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"addItems":"Add items","manageItems":"Manage items"},"fr_FR":{"addItems":"Ajouter des items","manageItems":"Gérer les items"}}')
}


/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserForm_vue__ = __webpack_require__(74);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_752d6cfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserForm_vue__ = __webpack_require__(185);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_752d6cfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(186)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control is-expanded"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.userName),expression:"userName"}],staticClass:"input",attrs:{"placeholder":_vm.$t('participantName')},domProps:{"value":(_vm.userName)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.addUser($event)},"input":function($event){if($event.target.composing){ return; }_vm.userName=$event.target.value}}})]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('b-tooltip',{attrs:{"label":_vm.$t('helpText'),"position":"is-left","type":"is-dark","multilined":""}},[_c('a',{staticClass:"button"},[_c('span',{staticClass:"icon is-right has-text-info"},[_c('i',{staticClass:"fa fa-info-circle"})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"field is-grouped is-grouped-centered"},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",class:{ 'is-loading': _vm.isLoading },attrs:{"disabled":_vm.userName.trim() === '' || _vm.isLoading},on:{"click":_vm.addUser}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('join')))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-plus"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"join":"Join the event","participantName":"Enter your name or another guest\u0027s name","helpText":"Add participants to your event or, if you are a guest, enter your name to begin adding items!"},"fr_FR":{"join":"Ajouter un participant","participantName":"Entrez votre nom ou celui d\u0027un autre invité","helpText":"Ajoutez des participants à votre évènement ou, si vous êtes un invité, entrez votre nom pour commencer à ajouter des items !"}}')
}


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventEditForm_vue__ = __webpack_require__(75);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1df17694_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventEditForm_vue__ = __webpack_require__(188);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventEditForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1df17694_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventEditForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(189)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-card has-text-left"},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.$t('editEvent')))]),_vm._v(" "),_c('button',{staticClass:"delete",on:{"click":_vm.onClose}})]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('eventName')))]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eventName),expression:"eventName"}],staticClass:"input is-large",attrs:{"placeholder":"Event name"},domProps:{"value":(_vm.eventName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eventName=$event.target.value}}})])])]),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('div',{staticClass:"buttons"},[_c('button',{staticClass:"button is-success",class:{ 'is-loading': _vm.isUpdating },attrs:{"disabled":_vm.isLoading},on:{"click":_vm.updateEvent}},[_vm._v(_vm._s(_vm.$t('edit')))]),_vm._v(" "),_c('button',{staticClass:"button is-danger",class:{ 'is-loading': _vm.isDeleting },attrs:{"disabled":_vm.isLoading || !_vm.isInitiator()},on:{"click":_vm.deleteEvent}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('deleteEvent')))])]),_vm._v(" "),_c('button',{staticClass:"button",on:{"click":_vm.onClose}},[_vm._v(_vm._s(_vm.$t('cancel')))])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-exclamation-triangle"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 189 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"editEvent":"Edit the event","eventName":"On which occasion?","edit":"Edit","deleteEvent":"Delete the event","cancel":"Cancel","eventDeleted":"The event deleted successfully.","eventUpdated":"The event has been updated successfully."},"fr_FR":{"editEvent":"Modifier l\u0027événement","eventName":"Pour quelle occasion ?","edit":"Éditer","deleteEvent":"Supprimer l\u0027événement","cancel":"Annuler","eventDeleted":"Événement supprimé avec succès.","eventUpdated":"Événement mis à jour avec succès."}}')
}


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventFilters_vue__ = __webpack_require__(76);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a543ed_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventFilters_vue__ = __webpack_require__(191);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventFilters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54a543ed_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventFilters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-collapse',{staticClass:"card",attrs:{"open":_vm.isOpen},on:{"update:open":function($event){_vm.isOpen=$event}}},[_c('div',{staticClass:"card-header",attrs:{"slot":"trigger"},slot:"trigger"},[_c('p',{staticClass:"card-header-title"},[_vm._v("\n      "+_vm._s(_vm.$t('filters'))+"\n    ")]),_vm._v(" "),_c('a',{staticClass:"card-header-icon"},[_c('b-icon',{attrs:{"pack":"fa","size":"is-small","icon":_vm.isOpen ? 'chevron-up' : 'chevron-down',"type":"is-dark"}})],1)]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"field"},[_c('p',{staticClass:"control has-icons-left"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"input",attrs:{"placeholder":_vm.$t('filterByParticipants')},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_vm._l((_vm.types),function(type){return _c('b-checkbox',{key:type,attrs:{"native-value":type},model:{value:(_vm.typesFilter),callback:function ($$v) {_vm.typesFilter=$$v},expression:"typesFilter"}},[_c('b-tag',{attrs:{"type":_vm.getTypeColor(type)}},[_vm._v(_vm._s(_vm.$t('types.' + type)))])],1)})],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventInviteLink_vue__ = __webpack_require__(77);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67dccf09_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventInviteLink_vue__ = __webpack_require__(201);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventInviteLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67dccf09_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventInviteLink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(202)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-primary",staticStyle:{"background-color":"#42a5f5"}},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column is-half-tablet is-offset-one-quarter-tablet"},[_c('h1',{staticClass:"title is-4",staticStyle:{"font-weight":"bold"}},[_vm._v("\n            "+_vm._s(_vm.$t('invitePeople'))+"\n          ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle is-6",staticStyle:{"font-weight":"400"}},[_vm._v("\n            "+_vm._s(_vm.$t('copyAndShare'))+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"field has-addons"},[_c('p',{staticClass:"control is-expanded has-icons-left"},[_c('input',{staticClass:"input",attrs:{"id":"event-link","readonly":""},domProps:{"value":_vm.baseUrl + '/event/' + _vm.eventId}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('p',{staticClass:"control"},[_c('a',{ref:"copy-event-link-button",staticClass:"button is-info",attrs:{"data-clipboard-target":"#event-link"}},[_vm._v("\n                "+_vm._s(_vm.$t('copy'))+"\n              ")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-external-link"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"invitePeople":"Invite people","copyAndShare":"Copy and share the link to your Freatle list. Every person who has this link will be able to add items; no account required.","copy":"Copy","linkCopied":"The event link has been copied successfully."},"fr_FR":{"invitePeople":"Inviter des participants","copyAndShare":"Copiez et partagez le lien vers votre liste Freatle. Toute personne disposant du lien pourra ajouter des items ; pas de compte requis.","copy":"Copier","linkCopied":"Le lien de l\u0027événement a bien été copié."}}')
}


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventMissing_vue__ = __webpack_require__(78);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39914f32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventMissing_vue__ = __webpack_require__(204);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventMissing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39914f32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventMissing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(205)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"hero is-medium c-background--image"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('h1',{staticClass:"title is-size-1 has-text-white"},[_vm._v("\n        "+_vm._s(_vm.$t('title'))+"\n      ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle is-size-3 has-text-white"},[_vm._v("\n        "+_vm._s(_vm.$t('subtitle'))+"\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"button is-large is-primary",attrs:{"to":"/","exact":""}},[_vm._v(_vm._s(_vm.$t('createEvent')))])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"title":"Oops... it looks like this is not the event you\u0027re looking for!","subtitle":"Why not create a new one?","createEvent":"Create a new event"},"fr_FR":{"title":"Oops... l\u0027événement que vous recherchez a disparu !","subtitle":"Pourquoi ne pas en créer un nouveau ?","createEvent":"Créer un événement"}}')
}


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event"},[(_vm.event || !(!_vm.event && _vm.finishedLoading))?_c('event-invite-link',{attrs:{"event-id":_vm.id}}):_vm._e(),_vm._v(" "),(!_vm.finishedLoading)?_c('section',{staticClass:"hero is-medium c-background--image"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('b-loading',{attrs:{"active":""}}),_vm._v(" "),_c('h1',{staticClass:"title is-2 c-heading__title"},[_vm._v("\n          "+_vm._s(_vm.$t('loading'))+"\n        ")])],1)])]):_vm._e(),_vm._v(" "),(_vm.event)?_c('section',{staticClass:"hero is-warning c-background--image"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('h1',{staticClass:"title is-2 is-spaced c-heading__title"},[_vm._v("\n          "+_vm._s(_vm.event.name)+"\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle is-6 c-heading__subtitle"},[_vm._v("\n          "+_vm._s(_vm.$t('by'))+" "+_vm._s(_vm.event.initiator.name)+" · "+_vm._s(_vm.$d(new Date(_vm.event.createdAt), 'long', _vm.localeForDate))+"\n          "),_c('br'),_c('br'),_vm._v(" "),(_vm.isInitiator)?_c('button',{staticClass:"button is-small is-light",attrs:{"disabled":_vm.event.id === _vm.demoEventId},on:{"click":function($event){_vm.showEditEventModal = true}}},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('edit')))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"modal",class:{ 'is-active': _vm.showEditEventModal }},[_c('div',{staticClass:"modal-background",on:{"click":function($event){_vm.showEditEventModal = false}}}),_vm._v(" "),_c('event-edit-form',{attrs:{"event":_vm.event,"on-close":function () { return _vm.showEditEventModal = false; }}})],1),_vm._v(" "),_c('div',{staticClass:"box"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-item has-text-centered"},[_c('div',[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.event.participants.length))]),_vm._v(" "),_c('p',{staticClass:"heading"},[_vm._v("Participants")])])])])])]),_vm._v(" "),_c('div',{staticClass:"columns is-multiline"},[(_vm.predefinedItemsList.items.length === 0 && _vm.isInitiator)?_c('div',{staticClass:"column is-12"},[_c('a',{staticClass:"button is-info is-rounded",on:{"click":function($event){_vm.isOpen = !_vm.isOpen}}},[_vm._m(1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('addPredefinedItems')))])])]):_vm._e(),_vm._v(" "),(_vm.predefinedItemsList.items.length > 0 || _vm.isOpen)?_c('div',{staticClass:"column is-12"},[_c('user-box',{attrs:{"user":_vm.predefinedItemsList,"event":_vm.event}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('user-form',{attrs:{"event-id":_vm.event.id}})],1),_vm._v(" "),_vm._l((_vm.event.participants),function(participant){return (participant.name.toLowerCase().includes(_vm.searchFilter.toLowerCase()))?_c('div',{staticClass:"column is-12 is-6-fullhd"},[_c('user-box',{attrs:{"user":participant,"event":_vm.event}})],1):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"column is-12"},[_c('event-filters')],1)],2)])])])]):_vm._e(),_vm._v(" "),(!_vm.event && _vm.finishedLoading)?_c('event-missing'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-pencil"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small"},[_c('i',{staticClass:"fa fa-plus"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__ = __webpack_require__(79);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53f7f410_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__ = __webpack_require__(209);
function injectStyle (ssrContext) {
  __webpack_require__(208)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53f7f410"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Help_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53f7f410_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Help_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* customBlocks */
var customBlock = __webpack_require__(210)
if (customBlock && customBlock.__esModule) {
  customBlock = customBlock.default
}
if (typeof customBlock === "function") {
  customBlock(Component)
}


/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"hero c-background--image"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title is-2 has-text-centered c-heading__title"},[_vm._v("\n          "+_vm._s(_vm.$t('helpTitle'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column is-8-desktop is-offset-2-desktop"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"content"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"help has-text-grey has-text-centered"},[_vm._v(_vm._s(_vm.$t('videoLegend')))])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v(_vm._s(_vm.$t('helpText')))])]),_vm._v(" "),_c('form',{attrs:{"action":"https://formspree.io/pulsar.dev.team@gmail.com","method":"POST","novalidate":""}},[_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('name')))]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.name),expression:"name"}],staticClass:"input",attrs:{"type":"text","placeholder":_vm.$t('enterName'),"name":"name","required":""},domProps:{"value":(_vm.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.name=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('email')))]),_vm._v(" "),_c('div',{staticClass:"control has-icons-left has-icons-right"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"input",class:{'is-danger': this.email && !_vm.isValidEmail},attrs:{"type":"text","placeholder":_vm.$t('enterEmail'),"name":"email","required":""},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),(this.email && !_vm.isValidEmail)?_c('span',{staticClass:"icon is-small is-right"},[_c('i',{staticClass:"fa fa-warning"})]):_vm._e()]),_vm._v(" "),(this.email && !_vm.isValidEmail)?_c('p',{staticClass:"help is-danger"},[_vm._v(_vm._s(_vm.$t('emailError')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"field"},[_c('label',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('message')))]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"textarea",attrs:{"placeholder":_vm.$t('enterMessage'),"name":"message","required":""},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('button',{staticClass:"button is-primary",attrs:{"disabled":!_vm.canSubmit()}},[_vm._v(_vm._s(_vm.$t('submit')))])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{staticClass:"c-video c-video--is-responsive",attrs:{"controls":"","loop":""}},[_c('source',{attrs:{"src":"/static/help-event-creation.mp4","type":"video/mp4"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon is-small is-left"},[_c('i',{staticClass:"fa fa-envelope"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en_US":{"helpTitle":"What can we do for you?","helpText":"If you need help or if you have any question, you can contact us by using the following form.","name":"Name","email":"Email","message":"Message","enterName":"Enter your name","enterEmail":"Enter your email","emailError":"Your email is invalid","enterMessage":"Enter your message","submit":"Submit","videoLegend":"Demonstration video of an event creation"},"fr_FR":{"helpTitle":"Pouvons-nous vous aider ?","helpText":"Si vous avez besoin d\u0027aide ou si vous avez des questions, vous pouvez nous contacter à l\u0027aide du formulaire suivant.","name":"Nom","email":"Email","message":"Message","enterName":"Entrer votre nom","enterEmail":"Entrer votre email","emailError":"Votre email n\u0027est pas valide","enterMessage":"Entrer votre message","submit":"Envoyer","videoLegend":"Vidéo de démonstration de la création d\u0027un événement"}}')
}


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules__ = __webpack_require__(80);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  modules: __WEBPACK_IMPORTED_MODULE_4__modules__["default"],
  strict: debug
}));

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decrementMain", function() { return decrementMain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "incrementMain", function() { return incrementMain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mutation_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(24);



var decrementMain = function decrementMain(_ref) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["b" /* DECREMENT_MAIN_COUNTER */]);
};

var incrementMain = function incrementMain(_ref2) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["c" /* INCREMENT_MAIN_COUNTER */]);
};

// Language
var changeLanguage = function changeLanguage(_ref3, payload) {
  var commit = _ref3.commit;

  __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].locale = payload;
  localStorage.setItem('locale', payload);
  commit(__WEBPACK_IMPORTED_MODULE_0__mutation_types__["e" /* UPDATE_LOCALE */], payload);
};

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mainCounter", function() { return mainCounter; });
var mainCounter = function mainCounter(state) {
  return state.counters.main;
};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./counters.js": 215,
	"./filters.js": 216,
	"./index.js": 80,
	"./language.js": 48
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 214;

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(15);


var _mutations;



var state = {
  main: 0
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* DECREMENT_MAIN_COUNTER */], function (state) {
  state.main--;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* INCREMENT_MAIN_COUNTER */], function (state) {
  state.main++;
}), _mutations);

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__(15);


var _mutations;



var state = {
  search: '',
  types: []
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* UPDATE_SEARCH */], function (state, payload) {
  state.search = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* ADD_TYPE */], function (state, payload) {
  if (state.types.indexOf(payload) === -1) {
    state.types.push(payload);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* REMOVE_TYPE */], function (state, payload) {
  var index = state.types.indexOf(payload);
  if (index !== -1) {
    state.types.splice(index, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* UPDATE_TYPES */], function (state, payload) {
  state.types = payload;
}), _mutations);

/* harmony default export */ __webpack_exports__["default"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[91]);


// WEBPACK FOOTER //
// static/js/app.811b96ae34b65d5f9241.js